import { Component, OnInit } from "@angular/core";
import { AuthSignInService } from "src/app/services/authentication/auth-signin.service";



export const Vendor = [
  {
    id: 1,
    title: "Exponential Interactive. Inc d/b/a VDX.tv",
    content: "Cookies duration: 90 (days). Cookie duration resets each session",
    cLink: "#",
    extra: {
      ex1: "View details",
      ex2: "Privacy Policy",
    },
    checks: [
      {
        id: 1,
        title: "Consent",
        check: false,
      },
      {
        id: 2,
        title: "Legitimate interest ",
        check: true,
      },
    ],
  },
  {
    id: 2,
    title: "Roq.ad Inc.",
    content:
      "Cookies duration: 365 (days). Cookie duration resets each session.",
    cLink: "#",
    extra: {
      ex1: "View details",
      ex2: "Storage details",
      ex3: "Privacy Policy",
    },
    checks: [
      {
        id: 1,
        title: "Consent",
        check: false,
      },
    ],
  },
];

export let ManageSettingsData = [
  {
    id: 1,
    title: "Store and/or access information on a device",
    content:
      "Cookies, device identifiers, or other information can be stored or accessed on your device for the purposes presented to you.",
    options: [
      {
        id: 1,
        title: "Consent",
        checked: false,
        icon: false,
      },
    ],
  },
  {
    id: 2,
    title: "Select basic ads",
    content:
      "Ads can be shown to you based on the content you're viewing, the app you're using, your approximate location, or your device type.",
    options: [
      {
        id: 1,
        title: "Consent",
        checked: false,
        icon: false,
      },
      {
        id: 2,
        title: "Legitimate interest",
        checked: true,
        icon: true,
      },
    ],
  },
  {
    id: 3,
    title: "Create a Personalised ads profile",
    content:
      "A profile can be built about you and your interests to show you personalised content that is relevant to you.",
    options: [
      {
        id: 1,
        title: "Consent",
        checked: false,
        icon: false,
      },
      {
        id: 2,
        title: "Legitimate interest",
        checked: true,
        icon: true,
      },
    ],
  },
  {
    id: 4,
    title: "Select personalised content",
    content:
      "Personalised content can be shown to you based on a profile about you.",
    options: [
      {
        id: 1,
        title: "Consent",
        checked: false,
        icon: false,
      },
      {
        id: 2,
        title: "Legitimate interest",
        checked: true,
        icon: true,
      },
    ],
  },
  {
    id: 5,
    title: "Measured ad performance",
    content:
      "The performance and effectiveness of ads that you see or interact with can be measured.",
    options: [
      {
        id: 1,
        title: "Consent",
        checked: false,
        icon: false,
      },
      {
        id: 2,
        title: "Legitimate interest",
        checked: true,
        icon: true,
      },
    ],
  },
  {
    id: 6,
    title: "Measure content performance",
    content:
      "The performance and effectiveness of content that you see or interact with can be measured.",
    options: [
      {
        id: 1,
        title: "Consent",
        checked: false,
        icon: false,
      },
      {
        id: 2,
        title: "Legitimate interest",
        checked: true,
        icon: true,
      },
    ],
  },
  {
    id: 7,
    title: "Apply market research to generate audience insights",
    content:
      "Market research can be used to learn more about the audiences who visit sites/apps and view ads.",
    options: [
      {
        id: 1,
        title: "Consent",
        checked: false,
        icon: false,
      },
      {
        id: 2,
        title: "Legitimate interest",
        checked: true,
        icon: true,
      },
    ],
  },
  {
    id: 8,
    title: "Develop and improve products",
    content:
      "Your data can be used to improve existing systems and software, and to develop new products.",
    options: [
      {
        id: 1,
        title: "Consent",
        checked: false,
        icon: false,
      },
      {
        id: 2,
        title: "Legitimate interest",
        checked: true,
        icon: true,
      },
    ],
  },
  {
    id: 9,
    title: "Ensure security, prevent fraud and debug",
    content:
      "Your data can be used to monitor for and prevent fraudulent activity, and ensure systems and processes work properly and securely.",
    options: [],
  },
  {
    id: 10,
    title: "Technically deliver ads or content",
    content:
      "Your device can receive and send information that allows you to see and interact with ads.",
    options: [],
  },
  {
    id: 11,
    title: "Match and combine offline data sources",
    content:
      "Data from offline data sources can be combined with your online activity in support of one or more purposes.",
    options: [],
  },
  {
    id: 12,
    title: "Link different devices",
    content:
      "Different devices can be determined as belongings to you or your household in support of one or more of purposes",
    options: [],
  },
  {
    id: 13,
    title:
      "Receive amd use automatically-sent device characteristics for identification.",
    content:
      "Your device might be distinguished from other devices based on information it automatically sends, such as IP address or browser type.",
    options: [],
  },
  {
    id: 14,
    title: "Use precise geolocation data",
    content:
      "Your precise geolocation data can be used in support of one or more purposes. This means your location can be accurate to within several meters.",
    options: [
      {
        id: 1,
        title: "Consent",
        checked: false,
        icon: false,
      },
    ],
  },
];

export let ManageSettingsSiteData = [
  {
    id: 1,
    title: "Store and/or access information on a device",
    content:
      "Cookies, device identifiers, or other information can be stored or accessed on your device for the purposes presented to you.",
    options: [
      {
        id: 1,
        title: "Consent",
        checked: false,
        icon: false,
      },
    ],
  },
  {
    id: 2,
    title: "Select basic ads",
    content:
      "Ads can be shown to you based on the content you're viewing, the app you're using, you approximate location, or your device type.",
    options: [
      {
        id: 1,
        title: "Legitimate interest",
        checked: true,
        icon: true,
      },
    ],
  },
  {
    id: 3,
    title: "Create a Personalised ads profile",
    content:
      "A profile can be built about you and your interests to show you personalised content that is relevant to you.",
    options: [
      {
        id: 1,
        title: "Consent",
        checked: false,
        icon: false,
      },
    ],
  },
  {
    id: 4,
    title: "Select personalised content",
    content:
      "Personalised content can be shown to you based on a profile about you.",
    options: [
      {
        id: 1,
        title: "Legitimate interest",
        checked: true,
        icon: true,
      },
    ],
  },
  {
    id: 5,
    title: "Measured ad performance",
    content:
      "The performance and effectiveness of ads that you see or interact with can be measured.",
    options: [
      {
        id: 1,
        title: "Consent",
        checked: false,
        icon: false,
      },
    ],
  },
  {
    id: 6,
    title: "Measure content performance",
    content:
      "The performance and effectiveness of content that you see or interact with can be measured.",
    options: [
      {
        id: 1,
        title: "Legitimate interest",
        checked: true,
        icon: true,
      },
    ],
  },
  {
    id: 7,
    title: "Apply market research to generate audience insights",
    content:
      "Market research can be used to learn more about the audiences who visit sites/apps and view ads.",
    options: [
      {
        id: 1,
        title: "Legitimate interest",
        checked: true,
        icon: true,
      },
    ],
  },
  {
    id: 8,
    title: "Develop and improve products",
    content:
      "Your data can be used to improve existing systems and software, and to develop new products.",
    options: [
      {
        id: 1,
        title: "Legitimate interest",
        checked: true,
        icon: true,
      },
    ],
  },
];

@Component({
  selector: "app-cookie-modal",
  templateUrl: "./cookie-modal.component.html",
  styleUrls: ["./cookie-modal.component.css"],
})
export class CookieModalComponent implements OnInit {
  integraCookieName = "integrA Policies";
  integraCookieValue = "IntegrA Value";
  cookieExpireDay = 180;
  settings = false;
  hiddenPanel = false;
  integraPolicyData:any[] = [
    {
      id: 1,
      title: "user information",
    },
    {
      id: 2,
      title: "usage of user data",
    },
    {
      id: 3,
      title: "selling of user data",
    },
  ];

  selectedChoicesTCFVendors:any[] = [];
  selectedSiteChoices:any[] = []

  vendorData: any = Vendor;
  manageSettingsData: any[] = ManageSettingsData;
  siteData: any[] = ManageSettingsSiteData;

  constructor(private _AuthSignInService: AuthSignInService) {}

  ngOnInit(): void {
    //document.getElementById("manageSettings").style.display = "block";
  }

  ngAfterViewInit() {
    this._ValidateCookie();
  }

  _SetCookie(cookieName, cookieValue, expireDays) {
    const d = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie =
      cookieName + "=" + JSON.stringify(cookieValue) + ";" + expires + ";path=/";
  }

  _GetCookie(cookieName: any) {
    let name = cookieName + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  _DeleteCookie(cookieName, cookieValue) {
    let expires = "expires=Thu, 01 Jan 1870 00:00:00 UTC";
    document.cookie =
      cookieName + "=" + cookieValue + ";" + expires + ";path=/";
  }

  _ValidateCookie() {
    let cookie = this._GetCookie(this.integraCookieName);
    if (cookie !== "") {
      return;
    } else {
      setTimeout(() => {
        document.getElementById("settings").style.display = "block";
      }, 5000);
    }
  }

  __HandleSetCookie() {
    this.__ConfirmChoices();
    this._CloseAllSettings();
  }

  _HandleDeclineCookie() {
    this._DeleteCookie(this.integraCookieName, "");
    document.getElementById("id01").style.display = "none";
  }

  _CookieSettings() {
    this.settings = true;
    document.getElementById("settings").style.display = "block";
    this._HandleDeclineCookie();
  }

  _CheckValue(event: any) {
    console.log(event);
  }

  __ManageSettings() {
    document.getElementById("manageSettings").style.display = "block";
    document.getElementById("settings").style.display = "none";
  }

  _VendorSettings() {
    document.getElementById("vendors").style.display = "block";
    document.getElementById("manageSettings").style.display = "none";
  }

  _CloseSettings() {
    this.__Logout();
  }

  __ManageBackFunc() {
    document.getElementById("settings").style.display = "block";
    document.getElementById("manageSettings").style.display = "none";
  }

  _VendorsBack() {
    document.getElementById("vendors").style.display = "none";
    document.getElementById("manageSettings").style.display = "block";
  }

  _CloseAllSettings() {
    document.getElementById("settings").style.display = "none";
    document.getElementById("manageSettings").style.display = "none";
  }

  __OnToggleSwitch(event, data, options) {
    let Id = data.id;
    this.manageSettingsData.filter((item) => {
      if (item.id === Id) {
        item.options.forEach((opt) => {
          if (opt.id === options.id) {
            opt.checked = event.checked;
          }
        });
      }
    });
    //console.log(this.manageSettingsData);
  }

  __OnToggleSiteSwitch(event, data, options) {
    let Id = data.id;
    this.siteData.filter((item) => {
      if (item.id === Id) {
        item.options.forEach((opt) => {
          if (opt.id === options.id) {
            opt.checked = event.checked;
          }
        });
      }
    });
  }

  __AcceptAll() {
    // manage settings
    let Temp_Data = this.manageSettingsData;
    Temp_Data.forEach((item) => {
      if (item.options.length > 0) {
        item.options.forEach((option) => {
          option.checked = true;
        });
      }
    });
    this.manageSettingsData = Temp_Data;

    // Site data
    let tempSiteData = this.siteData;
    tempSiteData.forEach((item) => {
      if (item.options.length > 0) {
        item.options.forEach((option) => {
          option.checked = true;
        });
      }
    });
    this.siteData = tempSiteData;
  }

  __Logout() {
    this._AuthSignInService.LogOut()
  }

  __ConfirmChoices() {
    let Temp_Data = this.manageSettingsData;
    Temp_Data.forEach((item) => {
      let payload = {
        id: null,
        title: "",
        options: []
      }
      payload.id = item.id;
      payload.title = item.title;
      payload.options = item.options
      this.selectedChoicesTCFVendors.push(payload);
    });
    this._SetCookie(this.integraCookieName, this.selectedChoicesTCFVendors, this.cookieExpireDay);
    this._CloseAllSettings();
    //this._ConfirmSiteChoices();
  }

  _ConfirmSiteChoices() {
    this.siteData.forEach((item) => {
      let payload = {
        id: null,
        title: "",
        options: []
      }
      payload.id = item.id;
      payload.title = item.title;
      payload.options = item.options
      this.selectedSiteChoices.push(payload);

      console.log(this.selectedSiteChoices);
    });
  }
}
